
import { Component, Vue, Watch } from 'vue-property-decorator';
import BasePagina from '@/components/base/BasePagina.vue';
import BaseDialog from '@/components/base/BaseDialog.vue';
import BasePesquisa from '@/components/base/BasePesquisa.vue';
import BaseLista from '@/components/base/BaseLista.vue';
import BaseCampos from '@/components/base/BaseCampos.vue';
// Services
import ProdutoService from '@/services/produto.service';
// Models
import { ProdutoInterface } from '@/shared/models/produto/produto.interface';
import { ProdutoFilter } from '@/shared/models/produto/produto.filter';
import { BaseDialogInterface } from '@/shared/models/base/dialog.interface';
// UTILS
import Rules from '@/shared/utils/rules.util';

@Component({
  components: {
    BasePagina,
    BaseDialog,
    BasePesquisa,
    BaseLista,
    BaseCampos,
  },
})
export default class Produto extends Vue {
  private rules = Rules;

  public labelBotaoNovo = 'Novo Produto';

  public editedItem = {} as ProdutoInterface;

  public filtro = {} as ProdutoFilter;

  // Dialog
  public dialogInterface = {
    formTitle: '',
    dialog: false,
    textBotaoPrimario: 'Salvar',
    funcaoPrimaria() {
      //
    },
    fecharModal: this.fecharModalCriarEditar,
    colorBotaoPrimario: 'primary',
  } as BaseDialogInterface;

  // Campos do Dialog
  public readonlyCamposDialog = false;

  public readonlyEANCamposDialog = false;

  public lista: Array<ProdutoInterface> = [];

  public headers: Array<Record<string, any>> = [
    {
      text: 'EAN', value: 'ean', align: 'center', sortable: false,
    },
    {
      text: 'Descrição', value: 'descricao', align: 'center', sortable: false,
    },
    {
      text: 'Elegível', value: 'elegivel', align: 'center', sortable: false,
    },
    {
      text: 'Ação', value: 'acao', align: 'center', sortable: false,
    },
  ];

  public listaValues = [
    { value: 'elegivel', function: this.traduzirElegivel, icon: true },
  ];

  private traduzirElegivel(item: any) {
    return {
      icon: item.elegivel ? 'mdi-check' : 'mdi-close',
      color: item.elegivel ? 'green' : 'red',
      tooltip: item.elegivel ? 'Elegível' : 'Não Elegível',
    };
  }

  public colapses = [
    { titulo: 'Filtragem', nomeSlot: 'pesquisa' },
    { titulo: 'Lista de Produtos', nomeSlot: 'lista' },
  ];

  public listaCamposPesquisa = [
    {
      text: 'EAN', type: 'textField', value: 'ean', cols: '4',
    },
    {
      text: 'Descrição', type: 'textField', value: 'descricao', cols: '4',
    },
    {
      text: 'Elegível', type: 'selectField', value: 'elegivel', itemText: 'descricao', itemValue: 'boolean', items: this.getListaElegivel, cols: '4', clearable: true,
    },
  ];

  public listaCamposCriarEditarExcluir = [
    {
      text: 'Descrição', type: 'textField', value: 'descricao', cols: '12', counter: '100', maxlength: '100', required: true, rules: [this.rules.campo_obrigatorio],
    },
    {
      text: 'Elegível', type: 'selectField', value: 'elegivel', itemText: 'descricao', itemValue: 'boolean', items: this.getListaElegivel, cols: '12', required: true, rules: [this.rules.campo_obrigatorio], clearable: true,
    },
  ];

  public listaAcoes = [
    { tooltip: 'Editar', icon: 'mdi-square-edit-outline', function: this.abrirEditar },
    { tooltip: 'Excluir', icon: 'mdi-delete-outline', function: this.abrirExcluir },
  ];

  // Pesquisa
  async pesquisar(filtro: ProdutoFilter) {
    this.lista = await new ProdutoService().buscarPorFiltro(filtro);
  }

  async buscarTodos() {
    this.lista = await new ProdutoService().buscarTodos();
  }

  // Dialog de Editar
  private async abrirEditar(item: any) {
    this.dialogInterface.formTitle = 'Editar Produto';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.readonlyCamposDialog = false;
    this.readonlyEANCamposDialog = true;
    this.dialogInterface.funcaoPrimaria = this.atualizar;
    this.editedItem = await new ProdutoService().buscarPorEAN(item.ean);
    if (this.editedItem !== undefined) {
      this.dialogInterface.dialog = true;
    }
  }

  // Dialog de Criar
  private abrirCriar() {
    this.dialogInterface.formTitle = 'Novo Produto';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.readonlyCamposDialog = false;
    this.readonlyEANCamposDialog = false;
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.dialogInterface.funcaoPrimaria = this.salvar;
    this.editedItem = {} as ProdutoInterface;
    this.dialogInterface.dialog = true;
  }

  // Dialog de Excluir
  private async abrirExcluir(item: any) {
    this.dialogInterface.formTitle = 'Excluir Cupom';
    this.dialogInterface.textBotaoPrimario = 'Excluir';
    this.readonlyCamposDialog = true;
    this.readonlyEANCamposDialog = true;
    this.dialogInterface.colorBotaoPrimario = 'warning';
    this.dialogInterface.funcaoPrimaria = this.excluir;
    this.editedItem = await new ProdutoService().buscarPorEAN(item.ean);
    if (this.editedItem !== undefined) {
      this.dialogInterface.dialog = true;
    }
  }

  async salvar() {
    new ProdutoService().salvar(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditar();
        this.pesquisar(this.filtro);
      });
  }

  async atualizar() {
    new ProdutoService().atualizar(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditar();
        this.pesquisar(this.filtro);
      });
  }

  async excluir() {
    new ProdutoService().excluir(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditar();
        this.pesquisar(this.filtro);
      });
  }

  private fecharModalCriarEditar() {
    this.dialogInterface.dialog = false;
    this.editedItem = {} as ProdutoInterface;
  }

  private getListaElegivel() {
    return [
      { boolean: true, descricao: 'Sim' },
      { boolean: false, descricao: 'Não' },
    ];
  }

  mounted() {
    this.buscarTodos();
  }
}
